const data: any = {
  rt: {
    "b": {
      "thisOpponent": "este rival",
      "firstMatch": "Primer partido",
      "lastMatch": "Último partido · {{value}}",
      "oneRated": "vs {{name}} {{value}} · 1 partido valorado",
      "average": "vs {{name}} {{value}} · {{count}} partidos",
      "oneRatedMe": "contra mí {{value}} · 1 partido valorado",
      "averageMe": "contra mí {{value}} · {{count}} partidos",
      "comparisonControls": "Comparaciones históricas",
      "showH2H": "Promedios de enfrentamientos directos",
      "showOverall": "Promedios generales de todos los partidos"
    },
    "f": {
      "shot_accuracy": "Precisión de golpes",
      "call_accuracy": "Precisión en los cantos (dentro/fuera)",
      "confrontational_tendency": "Tendencia a la confrontación",
      "forehand": "Derecha",
      "backhand": "Revés",
      "service": "Saque",
      "return": "Resto",
      "volley": "Volea",
      "smash": "Remate",
      "drop_shot": "Dejada",
      "lob": "Globo",
      "stamina": "Resistencia",
      "speed": "Velocidad",
      "court_coverage": "Cobertura de pista",
      "tactics": "Táctica",
      "awareness": "Lectura del juego",
      "shot_variety": "Variedad de golpes",
      "winners": "Golpes ganadores",
      "unforced_errors": "Errores no forzados",
      "fh_topspin": "Derecha liftada",
      "fh_slice": "Derecha cortada",
      "bh_topspin": "Revés liftado",
      "bh_slice": "Revés cortado",
      "first_serve": "1er saque",
      "first_serve_speed": "Velocidad 1er saque",
      "second_serve": "2º saque",
      "second_serve_speed": "Velocidad 2º saque",
      "serve_flat": "Saque plano",
      "serve_kick": "Saque kick",
      "serve_slice": "Saque slice",
      "first_serve_pct_est": "1os saques dentro (est.)",
      "second_serve_pct_est": "2os saques dentro (est.)",
      "passing_shots": "Passing shot",
      "volley_d": "Volea",
      "tactics_d": "Táctica",
      "speed_d": "Velocidad",
      "stamina_d": "Resistencia",
      "composure": "Templanza",
      "concentration": "Concentración",
      "calmness": "Calma",
      "anxiety": "Ansiedad",
      "confidence": "Confianza",
      "fighting_spirit": "Garra competitiva",
      "mental_resilience": "Resiliencia mental",
      "belief_pre": "Creer en la victoria antes del partido",
      "belief_in": "Creer en la victoria durante el partido"
    },
    "g": {
      "movement": "Movimiento y colocación",
      "behaviour": "Comportamiento",
      "forehand": "Derecha",
      "backhand": "Revés",
      "serve": "Saque",
      "rally": "Peloteo y resto",
      "net": "Juego en la red",
      "physical": "Físico y táctica"
    },
    "h": {
      "shot_accuracy": "¿Con qué constancia fueron tus golpes donde querías?",
      "call_accuracy": "¿Cómo de precisos crees que fueron tus cantos de dentro/fuera?",
      "confrontational_tendency": "Tendencia a discusiones, tensión o enfrentamientos con el rival."
    },
    "dist": {
      "winnersIncl": "Golpes ganadores (aces incl.)",
      "unforcedIncl": "Errores no forzados (dobles faltas incl.)",
      "assignTo": "Asignar el {{n}}% restante a…",
      "countHint": "Registraste {{a}} aces y {{d}} dobles faltas.",
      "remainingInline": "Quedan {{n}}%",
      "complete": "Completo: 100% asignado",
      "assignRemainder": "Asignar aquí el {{n}}% restante",
      "tab": "Puntos",
      "title": "¿Cómo terminaban los puntos?",
      "helper": "Es tu estimación: no hace falta registrar punto por punto. Los números aproximados valen; también puedes dejarlo vacío.",
      "winners": "Golpes ganadores",
      "forced": "Errores forzados",
      "unforced": "Errores no forzados",
      "df": "Dobles faltas",
      "total": "Total",
      "remaining": "{{n}}% sin asignar",
      "over": "{{n}}% por encima de 100",
      "myTeam": "Mi pareja",
      "oppTeam": "Equipo rival"
    }
  },
  onboarding: {
    eyebrow: "Empezar",
    valueHistory: "Crea tu historial completo de partidos",
    valueStats: "Entiende tus estadísticas",
    valueImprove: "Sigue tu progreso con el tiempo",
    showMore: "Cómo funciona y funciones",
    showLess: "Mostrar menos",
    headlineDashboard: "Tu panel espera el primer partido",
    headlineMatches: "Registra un partido para iniciar tu historia",
    headlineStats: "Las estadísticas se desbloquean tras tu primer partido",
    intro: "Tennis Log convierte cada partido en información. Registra el primero en menos de un minuto y mira cómo tu panel, gráficos y coach IA cobran vida.",
    cta: "+ Registrar el primer partido",
    howTitle: "Cómo funciona",
    s1Title: "Añade un partido",
    s1Desc: "Toca «Nuevo partido», rellena fecha, rival, pista y resultados. Los desplegables lo hacen rápido.",
    s2Title: "Añade detalle (opcional)",
    s2Desc: "Juego a juego, condiciones, dobles faltas, valoraciones — todo lo que quieras, o solo el marcador.",
    s3Title: "Mira tus estadísticas",
    s3Desc: "Win rate, hold, break, sets, juegos, superficie, pista, rival — todo se actualiza al instante.",
    s4Title: "Obtén insights IA",
    s4Desc: "El análisis con IA está disponible cuando ya has registrado datos de partidos y, en general, aporta más información a medida que crece tu historial.",
    benefitsTitle: "Lo que verás al registrar partidos",
    b1Title: "Win rate global",
    b1Desc: "Filtra por año, formato (individual/dobles/mixto) y tipo (amistoso/oficial). Tendencias por temporada.",
    b2Title: "Sets, juegos, hold y break",
    b2Desc: "Más allá de V/D: cuánto sostienes saque, cuánto quiebras, diferencial de sets y juegos.",
    b3Title: "Stats de smartwatch",
    b3Desc: "Sube una captura de Mi Fitness, Garmin, Apple Watch o Zepp — la IA rellena calorías, BPM y zonas FC.",
    b4Title: "Heatmap juego a juego",
    b4Desc: "Descubre si te hundes en el juego 3 o cierras el 11 — por lado de saque y set.",
    b5Title: "Valoraciones de rendimiento",
    b5Desc: "Puntúa derecha, revés, saque, resto, volea, lectura, cobertura. Todo en gráfico de radar.",
    b6Title: "Coach IA",
    b6Desc: "Una narrativa personal de fortalezas, debilidades y patrones — escrita como un coach, a partir de tus datos.",
    tipsTitle: "Consejos para tu primer registro",
    tip1: "Empieza simple: fecha, rival y resultado bastan.",
    tip2: "Añade pista y superficie — con el tiempo verás dónde juegas mejor.",
    tip3: "Prueba un set juego a juego para desbloquear hold rate y heatmaps.",
    tip4: "Valórate con honestidad — pocas entradas alimentan a la IA.",
    tip5: "¿Tienes partidos antiguos? Regístralos también. La historia crea estadística.",
  },
  nav: { dashboard: "Dashboard", matches: "Partidos", add: "Nuevo partido", stats: "Stats", insights: "AI Insights", logout: "Cerrar sesión" , settings: "Ajustes", invite: "Invita a un amigo" },
  brand: { name: "My Tennis Ledger", tagline: "Mejora estudiando tu historia de tenis" },
  auth: { age16: "Confirmo que tengo al menos 16 años. Las cuentas de Tennis Log son para personas de 16 años o más.", age16Required: "Confirma que tienes al menos 16 años.", signIn: "Iniciar sesión", signUp: "Registrarse", email: "Email", password: "Contraseña", name: "Nombre", createAccount: "Crear cuenta", or: "o", continueGoogle: "Continuar con Google", welcomeBack: "¡Bienvenido de nuevo!", accountCreated: "¡Cuenta creada!", passwordInfoLabel: "Requisitos de la contraseña", passwordHelp: "Usa al menos 8 caracteres. No se exigen mayúsculas, números ni símbolos, pero evita contraseñas muy comunes o fáciles de adivinar. No se aceptan contraseñas que hayan aparecido en filtraciones conocidas.", passwordTooShort: "La contraseña debe tener al menos 8 caracteres.", passwordWeakLeaked: "Esta contraseña es demasiado común o ha aparecido en una filtración conocida. Prueba con una más única.", passwordRejected: "No se aceptó esta contraseña. Revisa los requisitos junto al campo e inténtalo de nuevo.", passwordMinLabel: "Al menos 8 caracteres", requirementMet: "requisito cumplido", requirementNotMet: "requisito aún no cumplido", sameMethodHint: "Usa el mismo método de inicio de sesión que usaste al crear tu cuenta.", signInFailed: "El email o la contraseña son incorrectos. Si creaste tu cuenta con Google, inicia sesión con Google." },
  authPage: {
    heroTitle: "Empieza a construir tu historial de tenis",
    heroSubtitle: "Registra partidos en pocos minutos, detecta tus patrones y deja que tus estadísticas te muestren qué mejorar a continuación.",
    trustFree: "Funciones básicas gratis",
    trustData: "Tus datos siguen siendo tuyos",
    trustDevice: "Funciona en móvil y web",
    dashboardAlt: "Panel de Tennis Log con porcentaje de victorias, sets, games y hold",
    dashboardCaption: "Tras unos partidos, tu panel empieza a mostrar porcentaje de victorias, hold, breaks, tendencias e insights de IA.",
    founderQuote: "Creé Tennis Log porque quería dejar de olvidar mis propios partidos. Solo hace falta jugar, recordar la evolución del marcador y registrarlo. Estoy seguro de que también te será útil. ¡Disfrútalo!",
    founderTitle: "Fundador de Tennis Log — My Tennis Ledger",
    founderLocation: "Jugador avanzado de club, Grecia",
    notReadyTitle: "¿Aún no listo para registrarte?",
    notReadySub: "Explora primero el contenido público — todo abierto, sin cuenta.",
    viewDemoTitle: "Ver la demo pública",
    viewDemoDesc: "Mira lo que revela Tennis Log tras ~25 partidos — con gráficos reales.",
    readGuideTitle: "Lee la Guía de Estadísticas de Tenis",
    readGuideDesc: "Qué estadísticas importan de verdad y cómo leerlas.",
    browseBlogTitle: "Explora el Blog",
    browseBlogDesc: "Artículos sobre hold/break, tendencia de victorias, smartwatch, IA y juego mental.",
    open: "Abrir",
  },
  common: {
    all: "Todos", singles: "Individual", doubles: "Dobles", mixed: "Mixto",
    friendly: "Amistoso", official: "Oficial",
    me: "Yo", opponent: "Rival", year: "Año", draw: "Empate",
    cancel: "Cancelar", save: "Guardar", saving: "Guardando...", loading: "Cargando...",
    delete: "Eliminar", edit: "Editar", search: "Buscar", close: "Cerrar",
    matches: "partidos", other: "Otro (especificar)",
    loadFailed: "No se pudieron cargar tus datos", loadFailedBody: "Algo salió mal al cargar. Comprueba tu conexión e inténtalo de nuevo.", retry: "Reintentar",
  },
  conditions: { sun: "Sol en los ojos", wind: "Viento", noise: "Ruido / público", cold: "Frío", rain: "Lluvia", slippery: "Pista resbaladiza", humidity: "Humedad", strong_wind: "Viento fuerte" },
  dashboard: {
    title: "Dashboard", subtitle: "Tu temporada de un vistazo.",
    newMatch: "+ Nuevo partido", statsFilter: "Filtro stats", trendFilter: "Filtro tendencia",
    trendTitle: "Evolución del win rate", recent: "Partidos recientes", seeAll: "Todos →",
    noMatches: "Sin partidos.", addFirst: "Añade el primero",
    noFilter: "Sin partidos para este filtro.",
    overallWinRate: "Win rate global", winRate: "Win rate", clickDot: "Haz clic para editar el partido", sets: "Sets", games: "Juegos", holdRate: "Hold rate",
    breaksWon: "Breaks ganados", breaksWonSub: "{{breaks}} de {{total}} juegos al resto",
    serviceGames: "juegos al saque", returnGames: "juegos al resto",
    winAfterFirstSet: "Victoria tras ganar el 1er set", winAfterFirstSetSub: "{{wins}} de {{total}} partidos", surfaceFilter: "Superficie",
    setsWon: "Sets ganados", gamesWon: "Juegos ganados", breakRate: "Tasa de break",
    currentForm: "Forma actual", formEmpty: "Aún no hay partidos completados",
    trendDelta: "Win rate {{pp}} pp vs los 10 anteriores",
    trendStable: "Win rate estable vs los 10 anteriores",
    trendUnavailable: "Tendencia disponible tras {{count}} partidos",
    discovery: {
      title: "Lo que tu tenis te está diciendo",
      family: { improving: "Mejorando", edge: "Tu ventaja", watch: "Atención" },
    },
  },
  match: {
    opponentPrivacyHint: "Opcional. Estos datos son sobre otra persona: anota solo lo que te ayude en tu análisis y cíñete a los hechos.",
    basics: "Datos", players: "Jugadores", score: "Marcador por set",
    invalidSetScore: "Marcador imposible en el set {{set}} — el ganador debe alcanzar el objetivo y ganar por 2.", notes: "Notas",
    watch: "Datos del smartwatch", rating: "Valoración del partido (1–10)",
    surface: "Superficie", temperature: "Temperatura ({{unit}})",
    setType: "Tipo de set", standardSet: "Estándar", shortSet: "Short Set (a 4 juegos)", superTb: "Super TB (10p)", tb7: "Tie-break 7p", tb11: "Tie-break 11p",
    tbPointByPoint: "Punto por punto", tbUndo: "Deshacer", tbClear: "Borrar", tbDecided: "Decidido",
    date: "Fecha", time: "Hora", day: "Día", court: "Pista", courtCustomPlaceholder: "ej. Club Court #1",
    format: "Formato", kind: "Tipo",
    set: "Set", firstServer: "Primer saque:",
    missingOpponent: "Añade el nombre del rival para guardar el partido.", missingCourt: "Añade el nombre de la pista para guardar el partido.",
    opponentRequired: "Rival *", myPartner: "Mi compañero", oppPartner: "Compañero del rival",
    teams: "Equipos", teamsHint: "Mi equipo (yo + compañero) vs equipo rival (rival 1 + rival 2).",
    myTeam: "Mi equipo",
    opponentTeam: "Equipo rival",
    opponent1: "Rival 1",
    opponent2: "Rival 2",
    doublesPlayersRequired: "Añade a tu compañero y a los dos rivales para guardar el partido de dobles.",
    age: "Edad", experience: "Años de experiencia", backhand: "Revés", playstyle: "Estilo de juego",

    notesPlaceholder: "¿Cómo fue el partido?",
    summaryTab: "Resumen", detailedTab: "Detallado",
    watchHint: "Sube una captura de Mi Fitness/Garmin/Apple Watch — autocompletado por IA.",
    ratingHint: "Deja en blanco lo que no quieras valorar.",
    saveMatch: "Guardar", saveChanges: "Guardar",
    addTitle: "Nuevo partido", addSubtitle: "Rellena los datos.",
    editTitle: "Editar partido", editSubtitle: "Actualiza y guarda.",
    saved: "¡Partido guardado!", changesSaved: "¡Cambios guardados!", notFound: "Partido no encontrado",
    retired: "¿Hubo retirada?", retiredNone: "No", retiredYes: "Sí", retiredMe: "Me retiré", retiredOpp: "Rival retirado",
    specialEnding: "Final especial del partido",
    scoreMismatchTitle: "El marcador no coincide",
    scoreMismatchBody: "Por la progresión que registraste sale {{derived}}, pero en el marcador final indicaste {{declared}}. Revísalo antes de continuar.",
    scoreMismatchFix: "Corregir marcador final",
    declaredScore: "Marcador declarado",
    declaredScoreHint: "Este es el marcador final del Paso 1. Ahora dinos cómo se desarrolló el set.",
    declaredScorePrompt: "Declaraste que el <highlight>Set {{set}} terminó {{score}}</highlight>. Ahora dinos cómo evolucionó el marcador.",
    incompleteSetTimePrompt: "Declaraste que el <highlight>Set {{set}} llegó hasta {{score}}</highlight>, pero no terminó, probablemente porque se agotó el tiempo. Introduce solo los games que se jugaron para que se tengan en cuenta en el Elo.",
    timelineLiveScore: "Marcador juego a juego en curso",
    scoreMismatchBlock: "El marcador juego a juego no coincide con el marcador final. Corrige la diferencia antes de continuar.",
    gameSequenceNext: "Introduce los juegos en orden · Siguiente: Juego {{game}}",
    gameSequenceGap: "Falta el Juego {{missing}} antes del Juego {{later}}. Complétalo primero.",
    gameSequenceBlock: "Completa los juegos que faltan en orden antes de continuar.",
    doubleFaults: "Dobles faltas",
    dfMe: "Mis dobles faltas",
    dfOpp: "Dobles faltas del rival",
    aces: "Aces",
    acesMe: "Mis aces",
    acesOpp: "Aces del rival",
    context: "Contexto y condiciones",
    contextHint: "Factores externos y personales que pudieron influir.",
    conditions: "Condiciones físicas",
    personalIssues: "Dificultades personales",
    personalIssuesPlaceholder: "p.ej. dolor de cabeza, rodilla, jet lag…",
    psychTab: "Psicología",
    oppAge: "Edad del rival",
    oppBackhand: "Revés del rival",
    bhSingle: "A una mano",
    bhDouble: "A dos manos",
    oppPlaystyle: "Estilo de juego",
    styleOffensive: "Ofensivo",
    styleDefensive: "Defensivo",
    styleAllCourt: "All-court",
    floodlights: "Bajo focos",
    rainy: "Lluvia",
    tiringDay: "Día agotador / duro de trabajo",
    napped: "Siesta al mediodía",
    heavyMeal: "Comida pesada",
    fasted: "En ayunas",
    anxiousFlag: "Ansioso",
    tournamentRound: "Ronda del torneo",
    tournamentName: "Nombre del torneo",
    sleepHours: "Horas de sueño anoche",
    ballsState: "Estado de las bolas",
    ballsNew: "Nuevas", ballsUsed: "Usadas",
    ballsUseCount: "Cuántas veces usadas",
    ballsUseSuffix: "x",
    oppExperience: "Años de experiencia",
    racketStrungAt: "Raqueta encordada el",
    racketStrungAgo: "hace {{n}} días",
    racketStrungToday: "hoy",
    individualConditions: "Condiciones personales",
    daysSinceLastMatch: "Días desde el último partido",
    daysAgo: "hace {{n}} días",
    ballsUsed1: "Usadas 1x", ballsUsed2: "Usadas 2x", ballsUsed3: "Usadas 3x",
    oppHandedness: "Mano", righty: "Diestro", lefty: "Zurdo",
    weightKg: "Peso ({{unit}})", bmi: "IMC", bmiNoHeight: "Configura tu altura en el perfil para calcular el IMC",
    hLegend: "H = Hold", bLegend: "B = Break",
    cellHowTo: "Un clic en la celda del sacador para Hold (H), doble clic para Break (B). Otro clic borra la celda.",
    gameDetail: {
      toggle: "Añadir detalle por juego",
      toggleHint: "Opcional: toca un juego terminado para registrar hasta qué puntuación llegó quien lo perdió.",
      gameN: "Juego {{n}}",
      openSheet: "Añadir detalle",
      youServed: "sacaste tú", oppServed: "sacó el rival",
      held: "hold", wasBroken: "te rompieron", oppHeld: "hold del rival", youBroke: "rompiste",
      question: "¿Hasta dónde llegó quien perdió el juego?",
      deuce: "Deuce",
      gamePointQuestion: "¿Tuvo alguna bola de juego quien perdió?",
      yes: "Sí", no: "No",
      clearDetail: "Borrar detalle", changeResult: "Cambiar resultado",
      hold: "Hold", break: "Break", clearResult: "Borrar resultado",
      token: { "0": "Llegó a 0", "15": "Llegó a 15", "30": "Llegó a 30", D: "Deuce, sin bola de juego", DG: "Deuce, con bola de juego" },
    },
  },
  matches: {
    title: "Partidos", subtitle: "Todo tu histórico.",
    searchOpponent: "Buscar rival", searchPlaceholder: "p.ej. García",
    format: "Formato", confrontation: "Tipo",
    matchesCount: "{{count}} partidos",
    none: "Sin partidos", new: "+ Nuevo",
    setGameByGame: "Set {{n}} — juego a juego",
    confirmDelete: "¿Eliminar partido? No se puede deshacer.",
    deleted: "Eliminado",
    singular: "Individual", duplet: "Dobles", official: "Oficial", friendly: "Amistoso",
  },
  stats: {
    perGameSelectionDetails: "{{wins}} exitosos de {{total}} juegos registrados",
    trendSelectedMatch: "Partido seleccionado",
    trendOpenMatch: "Ver partido",
    tempStepLabel: "Intervalo de temperatura (°C)",
    ageStepLabel: "Intervalo de edad (años)",
    experienceStepLabel: "Intervalo de experiencia (años)",
    byMyBmiHint: "IMC = peso (kg) / altura² (m²). Según tu altura de perfil y tu peso registrado por partido.",
    byMyBmiNone: "Sin mediciones de IMC propio. Añade tu altura en Ajustes y peso por partido.",
    bmiBucketSize: "Intervalo de IMC",
    bmiSmallSampleHint: "Toca una barra para ver victorias y partidos. Intervalos muy estrechos con pocos partidos no permiten conclusiones fiables.",
    startTimeHalfHourHint: "Por intervalos de 30 minutos de inicio (18:30 incluye 18:30–18:59).",
    title: "Stats", subtitle: "Profundiza en los números.",
    none: "Sin partidos con marcador.",
    allOpponents: "Todos los rivales",
    gamesIServed: "Juegos al saque", holdRateOnServe: "Hold rate a mi saque",
    gamesIReceived: "Juegos al resto", opponentHolds: "Holds del rival", breaksIDid: "Breaks conseguidos",
    serviceStats: "Stats al saque", returnStats: "Stats al resto",
    holds: "Holds", breaksAgainst: "Breaks (en mi contra)", holdRate: "Hold rate ({{n}} juegos)",
    breaksWon: "Breaks ganados", breakRate: "Break rate ({{n}} juegos al resto)",
    smartwatch: "Stats smartwatch", smartwatchHint: "Promedios de tus capturas.",
    avgKcal: "Calorías medias", avgDuration: "Duración media", avgBpm: "BPM medio", maxBpm: "BPM máx (medio)",
    perfReport: "Informe de rendimiento",
    perfHint: "Promedios de las valoraciones (1–10).",
    perfNone: "Aún sin valoraciones.",
    trendTitle: "Evolución del win rate", h2h: "Cara a cara",
    byCourt: "Win rate por pista", byDay: "Por día",
    bySurface: "Por superficie", byTemp: "Por temperatura",
    surfaceNone: "Sin superficie registrada.", tempNone: "Sin temperatura registrada.",
    perGame: "Éxito por juego", set: "Set", scope: "Perspectiva",
    scopeAll: "Global", scopeServing: "Empezando al saque", scopeReturning: "Empezando al resto",
    metricWin: "Win rate", metricHold: "Hold rate (al saque)",
    fullTab: "Completo", allSet: "Todos los sets",
    perGameHint: "Tasa de éxito por número de juego.",
    firstBreakTitle: "Tasa de victoria por primer break", firstBreakHint: "¿Decide el primer break el resultado?",
    fbMe: "Rompí yo primero", fbOpp: "Rompió el rival primero", allSurfaces: "Todas las superficies",
    firstServerTitle: "Tasa de victoria por primer sacador", firstServerHint: "¿Influye quién empieza sacando en tu resultado?",
    fsMatch: "Partido completo", fsMe: "Empecé sacando yo", fsOpp: "Empezó sacando el rival",
    returnGames: "Juegos al resto", breakRateLabel: "Break rate", gameNumber: "Juego",
    hrZonesAvg: "Zonas cardíacas medias",
    hrZonesAvgHint: "Minutos medios por zona en {{n}} partidos con datos del reloj.",
    byYear: "Win rate por año", byMonth: "Win rate por mes",
    byCategoryKind: "Win rate por categoría y tipo",
    byOppAge: "Por edad del rival", byOppAgeHint: "Por franja de edad.", byOppAgeNone: "Edad del rival no registrada.",
    byOppExp: "Por experiencia del rival", byOppExpHint: "Años de tenis.", byOppExpNone: "Experiencia no registrada.",
    byOppLevel: "Tasa de victorias por nivel del rival", byOppLevelHint: "Nivel general del rival (1–10).", byOppLevelNone: "Aún no hay nivel del rival registrado.",
    byOppBmi: "Por IMC del rival", byOppBmiHint: "Índice de Masa Corporal = peso (kg) / altura² (m²).", byOppBmiNone: "Sin IMC del rival registrado. Añade altura y peso para ver este gráfico.",
    showTrend: "Mostrar tendencia", hideTrend: "Ocultar tendencia",
    byOppBackhand: "Por revés del rival", byOppBackhandNone: "Revés no registrado.",
    byBalls: "Por estado de bolas", byBallsNone: "Estado de bolas no registrado.",
    ballsNew: "Nuevas", ballsUsed: "Usadas", ballsUsedN: "Usadas ×{{count}}",

    byRainy: "Bajo la lluvia", byFloodlights: "Con focos",
    byDuration: "Por duración del partido", byStartTime: "Por hora de inicio",
    byMyBmi: "Por mi IMC",
    byOppHandedness: "Por mano del rival", byOppPlaystyle: "Por estilo del rival",
    byOppBirthMonth: "Porcentaje de victorias por mes de nacimiento del rival",
    bySleep: "Por horas de sueño", byTiringDay: "Tras día agotador",
    byNapped: "Con siesta", byHeavyMeal: "Tras comida pesada",
    byFasted: "En ayunas", byAnxious: "Con ansiedad",
    byCondition: "Por condición física", byPartner: "Por compañero",
    gameDetail: {
      whenServing: "Cuando saqué", whenReturning: "Cuando resté",
      held: "Mantuve", broken: "Me rompieron", opponentHeld: "El rival mantuvo", iBroke: "Rompí",
      deuce: "Iguales", pressure: "Presión",
      serviceCoverage: "Detalle registrado en {{detailed}} de {{total}} juegos al saque",
      returnCoverage: "Detalle registrado en {{detailed}} de {{total}} juegos al resto",
      smallSample: "Muestra pequeña · n={{count}}",
      noServiceData: "Aún no hay juegos al saque detallados", noReturnData: "Aún no hay juegos al resto detallados",
      unlock: "Añade detalles del juego al registrar para ver este desglose.",
      serviceTooltip: "{{percentage}}% · {{count}} de {{total}} juegos al saque detallados",
      returnTooltip: "{{percentage}}% · {{count}} de {{total}} juegos al resto detallados",
      serviceHeld: { "0": "Mantuve con el restador a 0", "15": "Mantuve con el restador a 15", "30": "Mantuve con el restador a 30", D: "Mantuve tras iguales", DG: "Mantuve tras afrontar un punto de break" },
      serviceBroken: { "0": "Me rompieron quedándome a 0", "15": "Me rompieron quedándome a 15", "30": "Me rompieron quedándome a 30", D: "Me rompieron tras iguales", DG: "Me rompieron después de tener punto de juego" },
      returnHeld: { "0": "El rival mantuvo conmigo a 0", "15": "El rival mantuvo conmigo a 15", "30": "El rival mantuvo conmigo a 30", D: "El rival mantuvo tras iguales", DG: "El rival mantuvo después de que yo tuviera punto de break" },
      returnBreak: { "0": "Rompí con el rival a 0", "15": "Rompí con el rival a 15", "30": "Rompí con el rival a 30", D: "Rompí tras iguales", DG: "Rompí después de que el rival tuviera punto de juego" },
    },
  },
  theme: { label: "Tema", court: "Noche en pista", clay: "Tierra batida", daylight: "Luz de día", grass: "Hierba", hardcourt: "Pista dura" },
  insights: {
    pageSubtitle: "Análisis de tus partidos con IA.",
    pickOpponent: "Rival",
    title: "Insights", subtitle: "Patrones de tus datos + coach IA.",
    askAi: "Pregunta a la IA", generating: "Generando…", aiNarrative: "Narrativa IA",
    notEnough: "Datos insuficientes — sigue registrando.",
    aiError: "No se pudieron generar los insights.",
  },
  insightsPreview: {
    title: "Lo que Tennis Log descubrirá",
    subtitle: "Registra tus partidos y Tennis Log irá aprendiendo los patrones detrás de tus resultados.",
    learningTitle: "Lo que Tennis Log está aprendiendo ahora",
    learningSubtitle: "Estas áreas necesitan algo más de historial antes de poder decir nada sobre ellas.",
    examplesLabel: "Ejemplos de lo que Tennis Log puede descubrir",
    badge: "Ejemplo",
    cta: "Registra tu primer partido",
    disclaimer: "Son ejemplos ilustrativos, no conclusiones sobre ti. No se basan en tus datos.",
    items: {
      serve: { text: "Rindes mejor en partidos ajustados cuando tu primer servicio funciona.", unlock: "Registra valoraciones de servicio en varios partidos para desbloquearlo." },
      opponents: { text: "Tus resultados ante rivales más fuertes están mejorando.", unlock: "Registra algunos partidos más con el nivel del rival para desbloquearlo." },
      pressure: { text: "Tus errores no forzados aumentan en sets de mucha presión.", unlock: "Registra algunos partidos más para descubrir si la presión afecta a tu rendimiento." },
      surface: { text: "Ganas más a menudo en una superficie que en otra.", unlock: "Registra partidos en distintas superficies para desbloquearlo." },
    },
  },
  gaps: {
    title: "Lo que Tennis Log aún no sabe",
    subtitle: "Cuanto más completos sean tus registros, más inteligente será tu coach de IA.",
    knowledgeTitle: "Conocimiento de la IA",
    knowledgeHint: "Una estimación de cuánta información útil hay disponible para un análisis de IA significativo.",
    loggedIn: "Registrado en el {{pct}}% de tus partidos.",
    notYet: "Aún no hay datos.",
    couldReveal: "Tennis Log podría revelar:",
    cta: "Empieza a registrarlo",
    doneTitle: "¡Excelente!",
    doneBody: "Tennis Log ya tiene datos suficientes para insights de IA de alta calidad. Sigue registrando partidos para ganar fiabilidad y descubrir nuevos patrones a largo plazo.",
    items: {
      selfRatings: {
        label: "Tus propias valoraciones",
        bullets: ["qué golpes deciden realmente tus partidos", "cómo cambia tu nivel entre sets", "tu progreso a lo largo de la temporada"],
      },
      opponentRatings: {
        label: "Valoraciones del rival",
        bullets: ["las fortalezas que importan ante rivales más fuertes", "debilidades que solo aparecen ante rivales de tu nivel", "análisis personalizado del enfrentamiento"],
      },
      sleep: {
        label: "Sueño",
        bullets: ["si el sueño afecta a tu porcentaje de victorias", "tu resistencia", "tu rendimiento en el tercer set"],
      },
      nutrition: {
        label: "Nutrición",
        bullets: ["cómo afectan las comidas al rendimiento", "si las comidas pesadas reducen tu constancia", "cómo el ayuno cambia tu resistencia"],
      },
      weather: {
        label: "Clima y condiciones",
        bullets: ["cómo el sol, el viento o la lluvia cambian tu juego", "tu rendimiento con focos", "tu rango de temperatura ideal"],
      },
      court: {
        label: "Pista y pelotas",
        bullets: ["tu mejor superficie", "cómo el estado de las pelotas afecta a tu ritmo", "qué instalaciones se adaptan a tu juego"],
      },
      emotions: {
        label: "Mente y energía",
        bullets: ["cómo los nervios afectan a los sets ajustados", "el impacto de un día agotador", "cuándo la calma da la vuelta a un partido"],
      },
      watch: {
        label: "Reloj inteligente",
        bullets: ["detección de fatiga", "patrones de recuperación", "correlaciones de pulso e intensidad"],
      },
    },
  },
  composite: {
    title: "Insights compuestos",
    subtitle: "Patrones que solo aparecen al combinar varias señales de tus partidos.",
    disclaimer: "Los insights compuestos describen correlaciones en tus datos, no causas demostradas. Aparecen solo cuando la muestra y la diferencia son suficientes.",
    showMore: "Ver {{count}} más",
    showLess: "Ver menos",
    direction: {
      positive: "Hallazgo positivo",
      negative: "Hallazgo negativo",
      neutral: "Hallazgo neutro",
    },
    cat: {
      momentum: "Momentum y desarrollo del partido",
      context: "Rendimiento según el contexto",
      opponent: "Análisis de rivales",
      physical: "Preparación física",
      development: "Evolución",
      matchup: "Análisis de enfrentamientos",
    },
    ev: {
      groups: "Ganaste {{aWins}} de {{aSample}} partidos ({{aRate}}%) {{aLabel}}, frente a {{bWins}} de {{bSample}} ({{bRate}}%) {{bLabel}}.",
      single: "Ganaste {{aWins}} de {{aSample}} partidos ({{aRate}}%).",
      ratingTrend: "Autoevaluación media de {{recentAvg}} en tus últimos {{recentN}} partidos, frente a {{prevAvg}} en los {{prevN}} anteriores.",
    },
    grp: {
      metricAbove: "cuando te puntuaste por encima de tu media en este aspecto: {{skill}}",
      metricBelow: "cuando tu puntuación fue igual o inferior a tu media",
      metricAboveSurface: "en {{surface}} cuando te puntuaste por encima de tu media en este aspecto: {{skill}}",
      metricBelowSurface: "en {{surface}} cuando tu puntuación fue igual o inferior a tu media",
      lostFirstSet: "tras perder el primer set",
      wonFirstSet: "tras ganar el primer set",
      long: "en partidos de más de 90 minutos",
      short: "en partidos de menos de 90 minutos",
      decider: "en partidos que llegaron al set decisivo",
      overall: "en todos tus partidos registrados",
      tiebreak: "en partidos con tie-break",
      surfaceOn: "en esta superficie: {{surface}}",
      surfaceOff: "en otras superficies",
      morning: "en partidos de mañana",
      afternoon: "en partidos de tarde y noche",
      floodlit: "con focos",
      daylight: "con luz natural",
      skillBetter: "cuando te valoraste mejor en este aspecto: {{skill}}",
      skillWorse: "cuando el rival estaba mejor valorado en ese aspecto",
      goodSleepLong: "en partidos largos tras 7 h o más de sueño",
      lowSleepLong: "en partidos largos tras dormir menos",
      goodSleepDecider: "en partidos con set decisivo tras 7 h o más de sueño",
      lowSleepDecider: "en partidos con set decisivo tras dormir menos",
      heavyMeal: "tras una comida pesada",
      noHeavyMeal: "sin comida pesada",
      recentPeriod: "en tus últimos {{n}} partidos",
      previousPeriod: "en los {{n}} partidos anteriores",
      h2hLostFirst: "contra este rival tras perder el primer set",
      h2hOverall: "contra este rival en total",
    },
    msg: {
      mentalPressureStrong: "En los momentos de presión decide la cabeza: {{skill}} — ganaste {{wins}} de {{sample}} partidos así ({{rate}}%) cuando te puntuaste por encima de tu media, frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) cuando no.",
      mentalPressureWeak: "En los momentos de presión la cabeza te cuesta partidos: {{skill}} — ganaste {{wins}} de {{sample}} ({{rate}}%) cuando te puntuaste por encima de tu media, frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) cuando no.",
      serveTightStrong: "En los sets ajustados tu saque marca la diferencia: {{skill}} — {{wins}} de {{sample}} ganados ({{rate}}%) cuando te puntuaste por encima de tu media, frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) cuando no.",
      serveTightWeak: "Los sets ajustados destapan una debilidad al saque: {{skill}} — {{wins}} de {{sample}} ganados ({{rate}}%) cuando te puntuaste por encima de tu media, frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) cuando no.",
      techniqueSurfaceStrong: "En {{surface}} un aspecto decide el resultado: {{skill}} — {{wins}} de {{sample}} ganados ({{rate}}%) cuando te puntuaste por encima de tu media, frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) cuando no.",
      techniqueSurfaceWeak: "En {{surface}} un aspecto te frena: {{skill}} — {{wins}} de {{sample}} ganados ({{rate}}%) cuando te puntuaste por encima de tu media, frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) cuando no.",
      comebackStrong: "Remontas bien tras perder el primer set — ganaste {{wins}} de {{sample}} partidos así ({{rate}}%).",
      comebackWeak: "Ahora mismo te cuesta remontar tras perder el primer set — ganaste solo {{wins}} de {{sample}} partidos así ({{rate}}%).",
      fadeLong: "Bajas en los partidos largos — {{wins}} victorias en {{sample}} partidos de más de 90 minutos ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) en los más cortos.",
      thriveLong: "Los partidos largos te van bien — {{wins}} victorias en {{sample}} partidos de más de 90 minutos ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) en los más cortos.",
      deciderStrong: "En los sets decisivos subes tu nivel — {{wins}} de {{sample}} partidos ganados ({{rate}}%), por encima de tu {{baseline}}% global.",
      deciderWeak: "Los sets decisivos te cuestan partidos — {{wins}} de {{sample}} partidos ganados ({{rate}}%), por debajo de tu {{baseline}}% global.",
      tiebreakStrong: "Los tie-breaks caen de tu lado — {{wins}} de {{sample}} partidos con tie-break ganados ({{rate}}%), por encima de tu {{baseline}}% global.",
      tiebreakWeak: "Los tie-breaks te cuestan partidos — {{wins}} de {{sample}} partidos con tie-break ganados ({{rate}}%), por debajo de tu {{baseline}}% global.",
      surfaceStrong: "Esta superficie te favorece: {{surface}} — {{wins}} victorias en {{sample}} partidos ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) en otras.",
      surfaceWeak: "Esta superficie es la más difícil para ti: {{surface}} — {{wins}} victorias en {{sample}} partidos ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) en otras.",
      morningBetter: "Por la mañana logras tus mejores resultados — {{wins}} de {{sample}} ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) más tarde.",
      eveningBetter: "Juegas mejor más tarde en el día — {{wins}} de {{sample}} ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) por la mañana.",
      floodlightsBetter: "Con focos tu juego aguanta mejor — {{wins}} de {{sample}} ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) con luz natural.",
      floodlightsWorse: "Los partidos con focos te resultan más difíciles — {{wins}} de {{sample}} ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) con luz natural.",
      strongOppSkill: "Ante rivales más fuertes un aspecto decide el partido: {{skill}} — {{wins}} de {{sample}} ganados ({{rate}}%) cuando te valoraste por encima.",
      strongOppWeak: "Ante rivales más fuertes no basta con estar mejor valorado en un aspecto: {{skill}} — {{wins}} victorias en {{sample}} partidos ({{rate}}%).",
      peerOppSkill: "Ante rivales de tu nivel un aspecto marca la diferencia: {{skill}} — {{wins}} victorias en {{sample}} partidos ({{rate}}%).",
      sleepLongMatches: "En los partidos largos el sueño se nota — {{wins}} de {{sample}} ganados tras 7 h o más ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) con menos.",
      fatigueThirdSet: "En los partidos con set decisivo — {{wins}} de {{sample}} ganados tras 7 h o más de sueño ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) con menos.",
      mealStrongOpp: "Ante rivales más fuertes se nota la comida pesada — {{wins}} de {{sample}} ganados sin comida pesada ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) con ella.",
      skillRising: "Un aspecto va al alza: {{skill}} — unos +{{diff}} puntos de valoración en tus últimos {{sample}} partidos.",
      skillFalling: "Un aspecto va a la baja: {{skill}} — unos -{{diff}} puntos de valoración en tus últimos {{sample}} partidos.",
      formUp: "Tu forma reciente sube — ganaste {{wins}} de tus últimos {{sample}} partidos ({{rate}}%), frente a {{otherWins}} de los {{otherSample}} anteriores ({{otherRate}}%), ante rivales de nivel similar.",
      formDown: "Tu forma reciente ha bajado — ganaste {{wins}} de tus últimos {{sample}} partidos ({{rate}}%), frente a {{otherWins}} de los {{otherSample}} anteriores ({{otherRate}}%), ante rivales de nivel similar.",
      matchupSkill: "Contra {{opponent}} un aspecto decide los duelos: {{skill}} — {{wins}} de {{sample}} ganados ({{rate}}%) cuando te valoraste por encima.",
      matchupFirstSet: "Contra {{opponent}} cuesta remontar un primer set perdido — {{wins}} de {{sample}} ganados ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) en total.",
      matchupComeback: "Contra {{opponent}} un primer set perdido no decide nada — {{wins}} de {{sample}} ganados ({{rate}}%), frente a {{otherWins}} de {{otherSample}} ({{otherRate}}%) en total.",
    },
  },
  coach: {
    driverTitle: "Factor decisivo",
    driverLead: "Un aspecto decide la mayoría de tus partidos, en ambos sentidos: {{topic}}.",
    driverSupport: "Hasta ahora: {{goodWins}} victorias en {{goodSample}} partidos ({{goodRate}}%) cuando funcionó, frente a {{badWins}} en {{badSample}} ({{badRate}}%) cuando no.",
    title: "Resumen del entrenador IA",
    subtitle: "Lo más importante que Tennis Log ha aprendido de tus partidos.",
    notEnough: "Aún no hay partidos suficientes para sacar conclusiones — sigue registrando.",
    strengthTitle: "Mayor fortaleza",
    weaknessTitle: "Mayor debilidad",
    possibleStrengthTitle: "Posible fortaleza",
    possibleWeaknessTitle: "Posible área de mejora",
    strengthLead: "Tus datos señalan aquí tu mayor fortaleza: {{topic}}.",
    weaknessLead: "Tus datos señalan aquí tu mayor debilidad: {{topic}}.",
    strengthLeadTentative: "Hay primeras señales de una fortaleza aquí: {{topic}}, pero la muestra todavía es pequeña.",
    weaknessLeadTentative: "Hay primeras señales de un área de mejora aquí: {{topic}}, pero la muestra todavía es pequeña.",
    focusTitle: "Foco para el próximo partido",
    focusOne: "En tu próximo partido, céntrate sobre todo aquí: {{first}}.",
    focusTwo: "En tu próximo partido, céntrate sobre todo aquí: {{first}}, y mantén como arma fiable: {{second}}.",
    disclaimer: "Son patrones que emergen de tus propios datos, no causas demostradas.",
    confidence: {
      high: "Fiabilidad alta",
      medium: "Fiabilidad media",
      low: "Fiabilidad baja",
    },
  },
  watch: {
    uploadScreenshot: "Subir captura", uploading: "Subiendo...", aiExtracting: "Extracción IA...",
    removeImage: "Quitar imagen", imageRequired: "Elige una imagen (PNG/JPG)",
    uploadFailed: "Subida fallida", extractFailed: "Extracción IA fallida",
    extracted: "¡Datos extraídos de la captura!",
    sourcesHint: "De Mi Fitness, Garmin, Apple Watch, Zepp, etc. Los campos se rellenan solos.",
    multipleHint: "Puedes subir más de una captura.",
    screenshotAlt: "Captura de entrenamiento del smartwatch",
    kcal: "Calorías (kcal)", duration: "Duración (min)", avgBpm: "BPM medio", maxBpm: "BPM máx",
    hrZones: "Zonas cardíacas", notes: "Notas del reloj", notesPlaceholder: "Efecto de entrenamiento, recuperación, etc.",
  },
  surfaces: { hard: "Dura", clay: "Tierra batida", grass: "Hierba", carpet: "Moqueta" },
  ad: { label: "Publicidad" },
  footer: {
    rights: "Todos los derechos reservados.",
    contact: "Contacto", contactTitle: "Contacta con Tennis Ledger",
    contactHint: "Envíanos un mensaje.",
    yourEmail: "Tu email", subject: "Asunto", message: "Mensaje", send: "Abrir email",
  },
  install: {
    iosCta: "Instalar en iPhone",
    platforms: "Disponible en Android · Funciona en iPhone",
    iosSheetTitle: "Usa Tennis Log como una app",
    iosSheetIntro: "Añade Tennis Log a tu pantalla de inicio en unos toques, sin App Store.",
    iosSheetStep1: "Abre Tennis Log en Safari",
    iosSheetStep2: "Toca el botón Compartir",
    iosSheetStep3: "Toca «Añadir a pantalla de inicio»",
    iosSheetStep4: "Toca «Añadir»",
    iosReassurance: "Tennis Log aparecerá en tu pantalla de inicio y se abrirá como una app.",
    iosNonSafari: "Para instalar Tennis Log en tu iPhone, abre esta página en Safari.",
    iosNonSafariHint: "Abre el menú del navegador y elige «Abrir en Safari»; después usa Compartir → Añadir a pantalla de inicio.",
    iosNudgeTitle: "Ten Tennis Log a un toque",
    iosNudgeBody: "Añade Tennis Log a tu pantalla de inicio para una experiencia de app.",
    iosNudgeShowMe: "Muéstrame cómo",
    iosNudgeDismiss: "Ahora no",
    cta: "Descargar app",
    loading: "La opción de instalación se está cargando, espera unos segundos",
    opening: "Abriendo el diálogo de instalación…",
    unavailable: "La opción de instalación no está disponible ahora mismo",
    title: "Instalar Tennis Log",
    hint: "Añade Tennis Log a tu dispositivo para abrirlo como una app real.",
    iosStep1: "Toca Compartir",
    iosStep2: "Luego selecciona «Añadir a pantalla de inicio».",
    iosStep3: "Toca «Añadir» arriba a la derecha",
    androidStep1: "Toca el menú del navegador ⋮",
    androidStep2: "Elige «Instalar aplicación» o «Añadir a pantalla de inicio».",
    androidStep3: "Confirma la instalación",
    desktopHint: "En Chrome o Edge de escritorio:",
    desktopStep1: "Haz clic en el icono de instalación en la barra de direcciones",
    desktopStep2: "O abre el menú del navegador y elige «Instalar Tennis Log».",
  },

  profileSetup: {
    "title": "Completa tu perfil de jugador",
    "subtitle": "Unos pocos datos hacen que tus estadísticas y análisis con IA sean mucho más precisos.",
    "dob": "Fecha de nacimiento",
    "level": "Tu nivel (1–10)",
    "levelHint": "1 = estás empezando, 10 = jugador competitivo de alto nivel.",
    "unitsMetric": "Métrico",
    "unitsUs": "EE. UU.",
    "later": "Más tarde",
    "saved": "Perfil actualizado",
    "ctaTitle": "Completa tu perfil de jugador",
    "ctaBody": "Tarda un minuto y afina todas las comparaciones de tus estadísticas.",
    "ctaAction": "Completar perfil",
    "countryPlaceholder": "Selecciona un país",
    "countrySearch": "Buscar país…",
    "countryEmpty": "No se encontró ningún país"
  },
  settings: {
    healthConsent: "Consentimiento de datos de salud",
    healthConsentActive: "Activo: permites que Tennis Log trate los datos de salud que añades a tus partidos.",
    healthConsentInactive: "No activo: no se tratan datos del smartwatch ni de pulsaciones.",
    healthConsentWithdraw: "Retirar consentimiento",
    healthConsentWithdrawn: "Consentimiento retirado y datos de salud borrados.",
    healthConsentPartial: "Consentimiento retirado. Algunos datos de salud aún no se han borrado; inténtalo de nuevo en breve.",
    healthConsentError: "No se pudo actualizar tu consentimiento. Inténtalo de nuevo.",
    healthConsentWithdrawHint: "Retirar el consentimiento borrará permanentemente las capturas de pantalla del smartwatch y los datos de salud importados (ritmo cardíaco, calorías, etc.).",
    healthConsentWithdrawTitle: "¿Retirar el consentimiento de datos de salud?",
    healthConsentWithdrawBody: "Esto borrará permanentemente las capturas de pantalla del smartwatch y los datos de salud importados, incluidos el ritmo cardíaco y las calorías guardados en tus partidos. No se puede deshacer.",
    healthConsentWithdrawKeepMatches: "Tus registros de partidos permanecerán; solo se eliminarán las capturas y los datos de salud almacenados.",
    healthConsentWithdrawConfirm: "Retirar consentimiento y borrar datos de salud",
    title: "Ajustes",
    profile: "Perfil",
    displayName: "Nombre visible",
    age: "Edad",
    country: "País",
    gender: "Género",
    gender_male: "Hombre", gender_female: "Mujer", gender_other: "Otro", gender_prefer_not: "Prefiero no decirlo",
    level: "Nivel de tenis",
    level_beginner: "Principiante", level_intermediate: "Intermedio", level_advanced: "Avanzado", level_competitive: "Competición",
    profileSaved: "Perfil guardado",
    password: "Contraseña",
    newPassword: "Nueva contraseña",
    changePassword: "Cambiar contraseña",
    pwdTooShort: "La contraseña debe tener al menos 6 caracteres",
    pwdChanged: "Contraseña cambiada",
    dataExport: "Exportación de datos",
    dataExportHint: "Descarga todos tus {{count}} partidos en CSV.",
    exportCsv: "Exportar a CSV",
    noMatchesExport: "Sin partidos para exportar.",
    exported: "{{count}} partidos exportados",
    units: "Unidades",
    unitsHint: "Elige cómo se muestran temperaturas y pesos. Tus datos siempre se guardan en °C y kg.",
    unitsMetric: "Métrico (°C, kg)",
    unitsUs: "EE. UU. (°F, lb)",
    cookiePrefs: "Preferencias de cookies",
    cookiePrefsHint: "Actualiza qué categorías de cookies permites.",
    manageCookies: "Gestionar cookies",
    diagnostics: "Aplicación y diagnósticos",
    diagnosticsHint: "Detalles técnicos que nos ayudan a reproducir un problema. No incluye nada personal.",
    diagnosticsCopy: "Copiar diagnósticos",
    diagnosticsCopied: "Diagnósticos copiados al portapapeles",
    diagnosticsCopyFailed: "No se pudo copiar — inténtalo de nuevo",
    reportProblem: "Informar de un problema",
    diagnosticsPasted: "Diagnósticos copiados — péguelos en su mensaje.",
    diagLanguage: "Idioma",
    diagUnits: "Unidades",
    diagDisplay: "Modo de visualización",
    diagDisplayStandalone: "Aplicación instalada (independiente)",
    diagDisplayBrowser: "Pestaña del navegador",
    diagBrowser: "Navegador",
    diagViewport: "Ventana de visualización",
    diagOrientation: "Orientación",
    diagHostname: "Nombre de host",
    dangerZone: "Zona peligrosa",
    deleteAccount: "Eliminar cuenta",
    deleteHint: "Elimina permanentemente tu cuenta y datos. No se puede deshacer.",
    deleteConfirmTitle: "¿Eliminar la cuenta?",
    deleteConfirmDesc: "Todos los partidos, datos del perfil y acceso se eliminarán permanentemente.",
    deleteForever: "Sí, eliminar",
    accountDeleted: "Cuenta eliminada",
    handedness: "Mano", righty: "Diestro", lefty: "Zurdo", heightCm: "Altura ({{unit}})",
  },
  cookies: {
    title: "Tu privacidad",
    intro: "Usamos cookies para que la app funcione y opcionalmente medir el uso. Elige qué permites.",
    necessary: "Estrictamente necesarias",
    necessaryDesc: "Necesarias para el acceso y funciones básicas. Siempre activas.",
    analytics: "Analíticas",
    analyticsDesc: "Estadísticas anónimas para mejorar la app.",
    marketing: "Marketing",
    marketingDesc: "Usadas por redes publicitarias para personalizar.",
    acceptAll: "Aceptar todo",
    rejectAll: "Rechazar todo",
    customize: "Personalizar",
    savePrefs: "Guardar preferencias",
  },
  invite: {
    title: "Invita a un amigo",
    subtitle: "Comparte My Tennis Ledger — escanea el QR o copia el enlace.",
    copyLink: "Copiar enlace",
    share: "Compartir",
    copied: "¡Enlace copiado!",
    shareText: "Sigue tu historia de tenis con My Tennis Ledger:",
  },
  help: {
    eyebrow: "Centro de ayuda",
    title: "Cómo funciona Tennis Log",
    subtitle: "Un recorrido rápido por cada función, con capturas y consejos. Haz clic en una sección para ir directamente.",
    tocTitle: "En esta página",
    tocTroubleshooting: "Solución de problemas",
    tocWhoFor: "¿Para quién es Tennis Log?",
    tocAbout: "Acerca de Tennis Log",
    s1Title: "Primeros pasos",
    s1Body: "Crea una cuenta con email o Google. Llegarás al Dashboard — vacío por ahora. Toca «+ Nuevo partido» para registrar el primero.",
    s2Title: "El Dashboard",
    s2Body: "Seis resúmenes arriba: Win rate, Sets, Juegos, Hold rate, Breaks ganados y Forma actual. Cada uno refleja el filtro actual (año, formato, tipo). Debajo: tendencia del win rate y partidos recientes.",
    s3Title: "Añadir un partido",
    s3Body: "En New Match, empieza registrando el rival, la pista y el marcador para que el resultado quede guardado. Después usa Score Timeline, Opponent, Context, Performance Review y Smartwatch para añadir solo el nivel de detalle que realmente recuerdes. Puedes guardar primero el partido básico y volver más tarde para enriquecer el mismo registro.",
    s4Title: "Lista de partidos",
    s4Body: "Busca por rival, filtra por formato y tipo, haz clic en una fila para editar. Acciones masivas y exportación CSV en Ajustes.",
    s5Title: "Stats",
    s5Body: "Análisis profundo: cara a cara, por pista, superficie, temperatura, año/mes, edad y experiencia del rival, estado de pelotas, incluso por lluvia o focos.",
    s6Title: "AI Insights",
    s6Body: "Pulsa «Ask AI» para obtener una narrativa estilo coach basada en tu historial de partidos. El análisis con IA está disponible cuando ya has registrado datos de partidos y, en general, aporta más información a medida que crece tu historial. Al solicitar AI Insights solo se envían datos de partidos autorizados y filtrados para proteger la privacidad; los identificadores personales se eliminan o seudonimizan conforme a la Política de privacidad.",
    s7Title: "Importación Smartwatch",
    s7Body: "En la página Nuevo partido, baja hasta «Datos smartwatch», sube una captura de tu app del reloj y rellenaremos kcal, duración, BPM medio/máx y zonas de FC con IA.",
    s8Title: "Exportar & eliminar",
    s8Body: "Desde Ajustes puedes cambiar contraseña, gestionar cookies, exportar todo en CSV o eliminar permanentemente tu cuenta.",
    ctaTitle: "¿Listo para empezar?",
    ctaDesc: "Rápido y sencillo — verás tus primeras stats tras un partido.",
    ctaBtn: "Crea tu cuenta",
    troubleshootingTitle: "Solución de problemas",
    troubleshootingItems: [
      { q: "No puedo iniciar sesión", a: "Asegúrate de usar el mismo proveedor con el que te registraste (email o Google). Si olvidaste tu contraseña, usa el enlace de restablecimiento en la pantalla de inicio de sesión. ¿Sigues atascado? Usa el enlace de Contacto en el pie de página con el email que usaste." },
      { q: "Mi partido no se guardó", a: "Para guardar un partido, se requieren un rival y una pista. Las puntuaciones y los detalles adicionales pueden añadirse progresivamente. Si ves un mensaje de error rojo, el formulario indica qué campo falta. Los problemas de red también pueden bloquear el guardado — inténtalo de nuevo con una conexión estable." },
      { q: "Los AI insights no se generan", a: "Los AI insights necesitan al menos varios partidos registrados para encontrar patrones. Si tienes suficientes datos pero aún ves un error, el servicio de IA puede estar temporalmente limitado — espera un minuto e inténtalo de nuevo." },
      { q: "La captura del smartwatch no se analiza", a: "El parser funciona mejor con capturas claras y de alto contraste de Apple Watch, Garmin, Polar o Fitbit. Recorta cerca del resumen del entrenamiento y asegúrate de que el texto de frecuencia cardíaca y duración sea legible." },
      { q: "Los números de las estadísticas se ven mal", a: "La mayoría de las sorpresas en estadísticas vienen de un orden de saque faltante en partidos game-by-game — sin él, la app no puede calcular holds y breaks. Edita el partido y verifica quién sirvió primero en cada set." },
    ],
    whoTitle: "¿Para quién es Tennis Log?",
    whoIntro: "Tennis Log está hecho para cualquier jugador que quiera tomarse su tenis un poco más en serio que solo recordar el marcador de camino a casa. Funciona igual de bien si llevas tres meses o tres décadas jugando — la profundidad de la herramienta escala con la profundidad de tu registro de partidos.",
    whoBeginnersTitle: "Principiantes",
    whoBeginnersBody: "Si acabas de empezar a jugar, lo más útil que te da Tennis Log es un registro simple y estructurado de tus primeros partidos. No necesitas registrar holds y breaks todavía. Solo registra rival, marcador, superficie y una nota de una línea. Después de 10-15 partidos, tendrás una base para mirar atrás seis meses después y decir «claramente soy mejor ahora», con pruebas en lugar de sensaciones.",
    whoIntermediateTitle: "Jugadores intermedios",
    whoIntermediateBody: "Para jugadores de club y liga, Tennis Log resulta especialmente útil. El seguimiento game-by-game ofrece porcentajes reales de hold y break. El análisis con IA está disponible cuando ya has registrado datos de partidos y, en general, aporta más información a medida que crece tu historial. Los filtros de superficie y rival ayudan a investigar diferencias, y un registro estructurado puede darte preguntas más claras para llevar al entrenamiento o a una sesión con tu entrenador.",
    whoCompetitiveTitle: "Jugadores competitivos",
    whoCompetitiveBody: "Si compites en torneos o una liga seria, Tennis Log funciona como una base de datos personal de rendimiento. Registra condiciones, mano del rival, valoraciones de ambos lados, datos del smartwatch, notas mentales — y segmenta las estadísticas resultantes por año, superficie, tipo (amistoso vs oficial), partner y más. Exporta a CSV en cualquier momento y lleva los datos a una sesión con tu entrenador.",
  },
  landing: {
    heroEyebrow: "El diario de tenis inteligente",
    heroTitle: "Deja de adivinar. Empieza a estudiar tu tenis.",
    heroDesc: "Tennis Log es un diario elegante para jugadores aficionados y competitivos. Registra cada partido, consulta estadísticas profundas y deja que la IA descubra los patrones que te frenan.",
    featuresTitle: "Todo lo que necesitas, nada que sobre",
    f1Title: "Registra cada partido en segundos",
    f1Desc: "Marcador por set, rival, pista, superficie, clima, incluso tus dobles faltas — los menús desplegables lo hacen sencillo.",
    f2Title: "Estadísticas que de verdad importan",
    f2Desc: "% de victorias, % de saques mantenidos, % de breaks, sets, juegos, rendimiento por superficie, pista y rival.",
    f3Title: "Insights con IA",
    f3Desc: "Recibe un análisis tipo entrenador personal — tus fortalezas, debilidades y patrones detectados en tu historial.",
    f4Title: "Importación desde smartwatch",
    f4Desc: "Sube una captura de Mi Fitness, Garmin, Apple Watch o Zepp — la IA rellena calorías, BPM y zonas de FC por ti.",
    f5Title: "Seguimiento juego a juego",
    f5Desc: "¿Quieres profundizar? Registra secuencias punto a punto y descubre tus tasas de éxito por juego.",
    f6Title: "7 idiomas",
    f6Desc: "EN · EL · ES · FR · DE · IT · JA — tu historial de tenis en tu idioma.",
    previewTitle: "Una mirada por dentro",
    shotDashLabel: "Panel", shotDashTitle: "Tu temporada de un vistazo",
    shotDashDesc: "Seis resúmenes cuentan la historia: porcentaje de victorias, sets, juegos, porcentaje de holds, breaks ganados y Forma actual. Cada uno refleja los filtros seleccionados.",
    shotAddLabel: "Añadir partido", shotAddTitle: "Registra un partido en menos de un minuto",
    shotAddDesc: "Empieza con Fast Track para guardar lo esencial y añade los detalles que quieras mediante Score Timeline, Opponent, Context, Performance Review y Smartwatch.",
    shotStatsLabel: "Estadísticas", shotStatsTitle: "Análisis profundo de los números",
    shotStatsDesc: "Individuales vs dobles, amistoso vs oficial, % de saques mantenidos, % de breaks, juegos al resto — cada estadística como prefieras.",
    shotTrendLabel: "Tendencia de victorias", shotTrendTitle: "Mira evolucionar tu forma",
    shotTrendDesc: "Filtra por individuales, dobles, amistoso u oficial — y observa tu % de victorias móvil partido a partido.",
    shotPerfLabel: "Rendimiento", shotPerfTitle: "Puntúate a ti y a tu rival",
    shotPerfDesc: "Puntúa derecha, revés, saque, resto, volea, dejada, globo, resistencia, velocidad y táctica — para ambos lados — y míralos en un gráfico radar.",
    shotPerGameLabel: "Éxito por juego", shotPerGameTitle: "Encuentra tu juego débil",
    shotPerGameDesc: "Descubre si fallas en el juego 3 o cierras el juego 11 — desglosado por lado de saque y set.",
    shotWatchLabel: "Smartwatch", shotWatchTitle: "Pulso, calorías, zonas — automático",
    shotWatchDesc: "Sube una captura de la app de tu reloj y la IA rellena calorías, duración, BPM medio, BPM máximo y zonas de FC.",
    howTitle: "Cómo funciona",
    s1Title: "Añade un partido", s1Desc: "Pulsa “+ Nuevo partido”, rellena marcador, rival y condiciones. Menos de un minuto.",
    s2Title: "Mira crecer tus estadísticas", s2Desc: "Tu panel se actualiza al instante. Filtra por año, formato, tipo — como prefieras.",
    s3Title: "Pregunta al entrenador IA", s3Desc: "Tras ~10 partidos, los Insights con IA detectan patrones: dónde fallas, dónde brillas.",
    s4Title: "Mejora, partido a partido", s4Desc: "Identifica qué funciona y dóblalo. Exporta a CSV cuando quieras.",
    trust1Title: "Privado y seguro", trust1Desc: "Tus datos son tuyos. Cifrados, nunca vendidos.",
    trust2Title: "Hecho para jugadores", trust2Desc: "Diseñado por jugadores de tenis, para jugadores de tenis.",
    trust3Title: "Tuyo, en 7 idiomas", trust3Desc: "EN · EL · ES · FR · DE · IT · JA.",
    faqTitle: "Preguntas frecuentes",
    faq1Q: "¿Cuánto cuesta Tennis Log?", faq1A: "Hoy, todas las funciones están disponibles sin coste — financiadas con anuncios discretos. Podríamos introducir planes de pago opcionales en el futuro para funciones avanzadas.",
    faq2Q: "¿Tengo que registrar cada punto?", faq2A: "Para nada. El registro más rápido es solo fecha + rival + marcadores. El detalle juego a juego es opcional.",
    faq3Q: "¿Cómo funciona la importación de smartwatch?", faq3A: "Haz una captura del resumen de tu entrenamiento en cualquier app de reloj, súbela y nuestra IA extrae calorías, duración, BPM medio y máximo, además de zonas de FC.",
    faq4Q: "¿Puedo exportar mis datos?", faq4A: "Sí — exporta todo a CSV cuando quieras desde Ajustes.",
  },
};

// ---- Heuristic insight labels & weekday names (added per-language) ----

data.insightsH = {
  "overall": "Tasa de victorias global",
  "overallDetail": "{{rate}}% en {{sample}} partidos decididos.",
  "better": "Mejor {{skill}} que el rival",
  "betterDetail": "Cuando eres mejor en {{skill}}, ganas el {{rate}}% ({{sample}} partidos). Referencia: {{baseline}}%.",
  "worse": "Peor {{skill}} que el rival",
  "worseDetail": "Cuando eres peor en {{skill}}, ganas el {{rate}}% ({{sample}} partidos).",
  "condDetail": "{{rate}}% en {{sample}} partidos (ref. {{baseline}}%).",
  "cond": {
    "oneHanded": "Vs revés a una mano",
    "twoHanded": "Vs revés a dos manos",
    "lowSleep": "Poco sueño (<6h)",
    "goodSleep": "Buen sueño (≥7h)",
    "tiring": "Día agotador",
    "floodlights": "Con focos",
    "rainy": "Tiempo lluvioso",
    "napped": "Siesta al mediodía",
    "heavyMeal": "Comida pesada",
    "fasted": "En ayunas",
    "anxious": "Ansioso",
    "newBalls": "Bolas nuevas",
    "official": "Partidos oficiales",
    "friendly": "Partidos amistosos",
    "singles": "Individuales",
    "doubles": "Dobles",
    "surface": "Superficie: {{surface}}"
  },
  "skill": {
    "shot_accuracy": "precisión de golpes",
    "call_accuracy": "precisión en los cantos",
    "confrontational_tendency": "calma ante la confrontación",
    "forehand": "derecha",
    "backhand": "revés",
    "service": "saque",
    "return": "resto",
    "volley": "volea",
    "drop_shot": "dejada",
    "lob": "globo",
    "stamina": "resistencia",
    "speed": "velocidad",
    "unforced_errors": "control de errores no forzados",
    "winners": "golpes ganadores",
    "tactics": "táctica",
    "awareness": "lectura del juego",
    "shot_variety": "variedad de golpes",
    "court_coverage": "cobertura de la pista",
    "fh_topspin": "liftado de derecha",
    "fh_slice": "cortada de derecha",
    "bh_topspin": "liftado de revés",
    "bh_slice": "cortada de revés",
    "first_serve": "primer saque",
    "first_serve_pct": "porcentaje de primer saque",
    "first_serve_speed": "velocidad del primer saque",
    "second_serve": "segundo saque",
    "second_serve_pct": "porcentaje de segundo saque",
    "second_serve_speed": "velocidad del segundo saque",
    "serve_flat": "saque plano",
    "serve_kick": "saque kick",
    "serve_slice": "saque cortado",
    "smash": "remate",
    "passing_shots": "passing shots",
    "composure": "temple",
    "concentration": "concentración",
    "calmness": "calma",
    "anxiety": "control de los nervios",
    "confidence": "confianza",
    "fighting_spirit": "garra competitiva",
    "mental_resilience": "resiliencia mental",
    "belief_pre": "confianza antes del partido",
    "belief_in": "confianza durante el partido"
  }
};
data.days = ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"];

data.quicklog = {
  "learnedAccordion": "Mira lo que Tennis Log ha aprendido hasta ahora",
  "savedIndicator": "Guardado",
  "fastTrackEyebrow": "Vía Rápida",
  "fastTrackTagline": "Registra un partido en menos de 30 segundos.",
  "revealMore": "¿Quieres respuestas más ricas? Descubre más abajo ↓",
  "bonus": "Extra",
  "continue": "Continuar",
  "meterTitle": "Ahora, Tennis Log puede calcular:",
  "meterSubtitle": "Estas estadísticas están disponibles hoy, según los partidos que registras.",
  "meterMoreTitle": "Descubre más para responder",
  "meterInfoAria": "Acerca de estas estadísticas",
  "editScore": "Editar marcador",
  "timelineNoScore": "Aún no se ha introducido marcador",
  "answers": {
    "winRate": "Porcentaje de victorias total",
    "history": "Historial de partidos",
    "gamesPct": "% de juegos ganados",
    "setsPct": "% de sets ganados",
    "monthly": "Porcentaje de victorias por mes",
    "dayOfWeek": "Porcentaje de victorias por día de la semana",
    "headToHead": "Cara a cara contra este rival"
  },
  "future": {
    "opponent": "Qué perfiles de rival se adaptan a tu juego",
    "timeline": "Cómo se desarrollan realmente tus partidos",
    "context": "Qué condiciones te ayudan a jugar tu mejor tenis",
    "review": "Qué habilidades tuyas te hacen ganar partidos",
    "watch": "Qué dice tu smartwatch sobre tu esfuerzo"
  },
  "stepTitles": {
    "fastTrack": "Vía Rápida",
    "opponent": "Rival",
    "timeline": "Cronología del marcador",
    "context": "Contexto y condiciones",
    "review": "Evalúa tu rendimiento",
    "watch": "Smartwatch"
  },
  "stepIntros": {
    "opponent": "Añade detalles del rival para que Tennis Log construya una imagen más rica de con quién juegas. Esto permite un análisis más profundo.",
    "timeline": "Registra cómo se desarrolló cada set. Esto permite un análisis más profundo de tus patrones de partido.",
    "context": "Captura las condiciones del partido. Esto permite un análisis más profundo del contexto.",
    "review": "Evalúa tu propio rendimiento. Esto permite un análisis más profundo de tus habilidades.",
    "watch": "¿Tienes un smartwatch? Sube una captura y deja que la IA lo complete todo automáticamente."
  },
  "stepUnlocksLabel": "Empezarás a alimentar el análisis de:",
  "unlocks": {
    "opponent": [
      "Resultados contra rivales zurdos",
      "Resultados contra jugadores experimentados",
      "Resultados por estilo de juego del rival",
      "Resultados contra revés a una mano"
    ],
    "timeline": [
      "Cómo ganas y pierdes tus sets",
      "Patrones de break y hold",
      "Consistencia de saque entre sets"
    ],
    "context": [
      "Cómo influyen las condiciones en tu juego",
      "Si el sueño o el descanso afectan a los resultados",
      "Cómo se relaciona el clima con tu rendimiento"
    ],
    "review": [
      "Qué habilidades correlacionan con tus victorias",
      "Qué debilidades te cuestan partidos",
      "Cómo evolucionan tus valoraciones con el tiempo"
    ],
    "watch": [
      "Calorías y duración",
      "Frecuencia cardíaca media y máxima",
      "Carga de entrenamiento y recuperación"
    ]
  },
  "successTitle": "Partido guardado.",
  "successBody": "Tennis Log ya puede responder estas preguntas sobre tu tenis:",
  "successCtaMatches": "Ver mis partidos",
  "successCtaContinue": "Añadir más detalles del partido — opcional",

  "addMoreDetails": "Añadir más detalles",
  "finish": "Terminar y guardar",
  "wantRicher": "¿Quieres respuestas más ricas?",
  "prev": "Atrás",
  "stepOf": "Paso {{current}} de {{total}}",
  "dontShowRewards": "No volver a mostrar",
  "canLabel": "Tennis Log ya puede identificar:",
  "learnedLabel": {
    "match": "Lo que Tennis Log ha aprendido de este partido:",
    "matches": "Lo que Tennis Log ha aprendido de tus partidos:",
    "tennis": "Lo que Tennis Log sabe sobre tu tenis:"
  },
  "hintLabel": "¿Tienes otro minuto?",
  "rewardTitles": {
    "fastTrack": "¡Partido guardado!",
    "timeline": "¡Excelente!",
    "opponent": "¡Genial!",
    "context": "¡Buen trabajo!",
    "review": "¡Fantástico!"
  },
  "rewardBodies": {
    "fastTrack": "Tu partido ya forma parte de tu historial de tenis.",
    "timeline": "Tennis Log ahora entiende mucho más sobre cómo se desarrollan tus partidos.",
    "opponent": "Tennis Log sabe ahora mucho más sobre los jugadores a los que te enfrentas.",
    "context": "Tennis Log puede ahora conectar tu rendimiento con las condiciones en las que jugaste.",
    "review": "Tu revisión de rendimiento da a Tennis Log una fuente rica de análisis a largo plazo."
  },
  "rewardHints": {
    "fastTrack": "Completa el siguiente paso y Tennis Log empezará a descubrir:",
    "timeline": "A continuación ayudarás a Tennis Log a entender a tus oponentes.",
    "opponent": "A continuación registrarás las condiciones del partido.",
    "context": "✨ ¿Tienes otro minuto? Evaluemos ahora el rendimiento de ambos jugadores.",
    "review": "Un último paso opcional: conecta tu smartwatch."
  }
};

// --- Progressive logging refinement (conversation-first copy) ---
Object.assign(data.match, {
  "oppGender": "Género del rival *",
  "genderMale": "Hombre",
  "genderFemale": "Mujer",
  "genderOther": "Otro",
  "oppLevel": "Nivel general del rival",
  "oppLevel1": "Principiante total",
  "oppLevel5": "Jugador medio de club",
  "oppLevel10": "El mejor al que me he enfrentado",
  "oppLevelHint": "7 = jugador fuerte de club · 9 = nivel de torneo",
  "oppBirthYear": "Año de nacimiento",
  "oppBirthMonth": "Mes",
  "oppBirthDay": "Día",
  "oppTennisSince": "Juega al tenis desde (año)",
  "oppTennisSinceCompact": "Juega desde",
  "oppLegacyValue": "guardado anteriormente",
  "oppBirthInvalid": "Introduce un año de nacimiento completo de 4 dígitos (desde 1900).",
  "oppAgePrev": "Edad registrada anteriormente",
  "oppExperiencePrev": "Años de experiencia registrados anteriormente",
  "oppSinceBeforeBirth": "El año de inicio en el tenis no puede ser anterior al año de nacimiento.",
  "oppSinceFuture": "El año de inicio en el tenis no puede estar en el futuro.",
  "oppSinceRange": "Introduce un año completo de 4 dígitos (desde 1900).",
  "oppStyleScore": "Defensivo ↔ agresivo",
  "oppStyleLegacy": "Registrado antes como: {{value}}",
  "oppLevelAvg": "Media de partidos anteriores: {{value}} ({{n}})",
  "oppLevelHistory": "Historial de nivel",
  "oppAttackTags": "Cómo me hizo daño",
  "oppErrorTags": "Dónde falla",
  "oppTagRemembered": "Visto en un partido anterior",
  "attackGroup_serve": "Saque y primer golpe",
  "attackGroup_shape": "Tipo de golpe",
  "attackGroup_target": "Dirección",
  "errorGroup_technical": "Técnicos",
  "errorGroup_situational": "De situación",
  "attackTag_big_first_serve": "Gran primer saque",
  "attackTag_aggressive_return": "Resto agresivo",
  "attackTag_serve_volley": "Saque y volea",
  "attackTag_takes_ball_early": "Golpea la bola temprano",
  "attackTag_heavy_topspin": "Liftado pesado",
  "attackTag_frequent_slice": "Cortada frecuente",
  "attackTag_drop_shots": "Dejadas",
  "attackTag_short_angles": "Ángulos cortos",
  "attackTag_effective_lobs": "Globos eficaces",
  "attackTag_attacks_my_backhand": "Ataca mi revés",
  "attackTag_attacks_my_forehand": "Ataca mi derecha",
  "attackTag_net_rusher": "Sube a la red",
  "attackTag_open_court": "Abre la pista",
  "attackTag_changes_direction": "Cambia de dirección",
  "errorTag_backhand_breaks_down": "Se le rompe el revés",
  "errorTag_forehand_breaks_down": "Se le rompe la derecha",
  "errorTag_high_balls": "Sufre con bolas altas",
  "errorTag_low_balls": "Sufre con bolas bajas",
  "errorTag_vs_heavy_topspin": "Sufre con el liftado pesado",
  "errorTag_vs_slice": "Sufre con la cortada",
  "errorTag_vs_drop_shots": "Sufre con las dejadas",
  "errorTag_volley_errors": "Errores de volea",
  "errorTag_return_errors": "Errores de resto",
  "errorTag_second_serve_errors": "Segundo saque flojo",
  "errorTag_errors_when_rushed": "Errores cuando le apuran",
  "errorTag_errors_on_the_run": "Errores en carrera",
  "errorTag_overhits": "Se pasa de fuerza",
  "errorTag_long_rallies": "Errores en puntos largos",
  "errorTag_under_pressure": "Errores bajo presión",
  "oppLevelEmpty": "Desliza para valorar el nivel general del rival.",
  "oppLevelDesc_10": "Principiante total",
  "oppLevelDesc_15": "Empieza a aprender",
  "oppLevelDesc_20": "Principiante con poca experiencia en partidos",
  "oppLevelDesc_25": "Desarrollando consistencia básica",
  "oppLevelDesc_30": "Jugador recreativo ocasional",
  "oppLevelDesc_35": "Jugador recreativo en progreso",
  "oppLevelDesc_40": "Jugador recreativo habitual",
  "oppLevelDesc_45": "Jugador recreativo sólido",
  "oppLevelDesc_50": "Jugador medio de club",
  "oppLevelDesc_55": "Jugador de club competitivo",
  "oppLevelDesc_60": "Jugador de club fuerte",
  "oppLevelDesc_65": "Jugador de club muy fuerte",
  "oppLevelDesc_70": "Jugador de club avanzado",
  "oppLevelDesc_75": "Jugador fuerte en torneos locales",
  "oppLevelDesc_80": "Jugador de torneo de alto nivel",
  "oppLevelDesc_85": "Jugador de torneo muy fuerte",
  "oppLevelDesc_90": "Amateur de élite / nivel regional",
  "oppLevelDesc_95": "Jugador excepcional",
  "oppLevelDesc_100": "El mejor jugador al que me he enfrentado",
  "oppAttackNotes": "¿Cómo ataca este rival?",
  "oppAttackNotesPlaceholder": "p. ej. saque potente, golpea la bola temprano…",
  "oppErrorNotes": "¿Cómo comete errores este rival?",
  "oppErrorNotesPlaceholder": "p. ej. sufre cuando le presionan el revés…"
});
data.quicklog.stepTitles.review = "Evaluación de los jugadores";
Object.assign(data.quicklog.stepIntros, {
  "fastTrack": "Solo lo esencial: unos 30 segundos.",
  "timeline": "¿Cómo se desarrolló el partido?",
  "opponent": "Cuéntanos un poco sobre tu rival.",
  "context": "Los detalles marcan la diferencia.",
  "review": "Valora el rendimiento de ambos jugadores: con el tiempo Tennis Log descubrirá qué te hace ganar.",
  "watch": "¿Tienes un smartwatch? Deja que Tennis Log complete el resto."
});
Object.assign(data.quicklog.rewardTitles, {
  "fastTrack": "¡Perfecto!",
  "timeline": "¡Excelente!",
  "opponent": "¡Genial!",
  "context": "¡Perfecto!",
  "review": "¡Gran trabajo!",
  "watch": "¡Todo listo!"
});
Object.assign(data.quicklog.rewardBodies, {
  "fastTrack": "Tu partido ya forma parte de tu historia personal de tenis.",
  "timeline": "Tennis Log entiende mucho mejor cómo se desarrollan tus partidos.",
  "opponent": "Tennis Log conoce mucho mejor a los rivales a los que te enfrentas.",
  "context": "Tu base de datos personal es aún más inteligente: Tennis Log ya puede conectar tu rendimiento con las condiciones.",
  "review": "Tu perfil tenístico es mucho más rico, y el de tu rival también. Tennis Log puede empezar a descubrir qué habilidades te dan victorias.",
  "watch": "Acabas de crear uno de los registros de partido más completos de tu viaje tenístico. Gracias por ayudar a Tennis Log a entender tu tenis."
});

data.guest = {
  "tryNow": "Pruébalo ahora — sin cuenta",
  "tryNowLine1": "Pruébalo ahora",
  "tryNowLine2": "Sin cuenta",
  "badge": "Sesión de invitado",
  "sumScore": "Marcador",
  "sumType": "Tipo de partido",
  "saveTitle": "Tu primer partido está listo.",
  "saveSubtitle": "Ya has registrado tu primer partido. Crea una cuenta gratuita para guardarlo de forma permanente y empezar tu historial de tenis.",
  "canTitle": "Tennis Log ya puede calcular",
  "beginningTitle": "Esto es solo el comienzo.",
  "beginningBody": "Continúa y Tennis Log aprenderá mucho más de cada partido que juegues.",
  "google": "Continuar con Google",
  "createAccount": "Crear cuenta",
  "haveAccount": "Ya tengo una cuenta",
  "editAgain": "Editar este partido",
  "whyLink": "¿Por qué necesito una cuenta?",
  "whyBody": "Tus partidos te pertenecen. Una cuenta permite a Tennis Log:",
  "whyB1": "guardar tu historial",
  "whyB2": "sincronizar entre dispositivos",
  "whyB3": "crear estadísticas a largo plazo",
  "whyB4": "generar insights con IA",
  "persisting": "Guardando tu partido…",
  "successTitle": "¡Perfecto!",
  "successBody": "Tu primer partido ya forma parte de tu historial de tenis.",
  "successContinue": "Añadir más detalles del partido — opcional"
};

data.appWelcome = {
  "heading": "Bienvenido a Tennis Log",
  "subheading": "Tu historia en la pista empieza con tu próximo partido.",
  "googleCta": "Continuar con Google",
  "googleHelper": "Rápido, seguro y sin contraseñas que recordar.",
  "guestCta": "Empezar sin cuenta",
  "guestHelper": "Registra ya tu primer partido. Podrás proteger tus datos con Google más tarde.",
  "haveAccount": "¿Ya tienes cuenta? Inicia sesión",
  "carouselTitle": "¿Qué pueden revelar 25 partidos?",
  "carouselSubtitle": "Cuantos más partidos registres, más claro se ve tu juego.",
  "carouselTitle2": "Tu Tennis Log crece con cada partido",
  "carouselSubtitle2": "Desliza para descubrir en qué se pueden convertir tus estadísticas.",
  "card4": "Cada sesión, calorías y pulsaciones",
  "card5": "Tus partidos en un calendario",
  "card1": "Tu temporada de un vistazo",
  "card2": "Mira cómo evoluciona tu juego",
  "card3": "Descubre patrones que no ves solo",
  "footer": "Funciones básicas gratis • Tus datos son tuyos • Hecho para jugadores de club",
  "prev": "Anterior",
  "next": "Siguiente",
  "mini": {
    "winRate": "% de victorias",
    "matches": "Partidos",
    "sets": "Sets ganados",
    "trend": "Evolución de victorias",
    "you": "Tú",
    "opponent": "Rival",
    "serve": "Saque",
    "forehand": "Derecha",
    "backhand": "Revés",
    "movement": "Movimiento",
    "strength": "Punto fuerte",
    "strengthBody": "Ganas el 78% de los partidos cuando logras el primer break.",
    "opportunity": "Oportunidad",
    "opportunityBody": "Tu revés baja en los terceros sets: un patrón físico o de concentración."
  }
};

data.consent = { health: { title: "Datos de salud — consentimiento explícito", body: "La frecuencia cardíaca, las zonas de pulsaciones, las calorías, la duración del entrenamiento y las capturas del smartwatch son datos de salud. Tennis Log solo los trata si lo autorizas expresamente, incluido su envío a un proveedor de IA para generar tus análisis. Es opcional y puedes retirarlo en cualquier momento en Ajustes, lo que borra los datos de salud ya guardados.", checkbox: "Doy mi consentimiento explícito para que Tennis Log trate mis datos de salud como se describe.", enable: "Activar datos de salud", optional: "Opcional: Tennis Log funciona igual sin ellos.", granted: "Datos de salud activados.", stale: "El texto de consentimiento se ha actualizado. Recarga la página y revísalo.", error: "No se pudo guardar tu elección. Inténtalo de nuevo.", } };

data.share = {
  button: "Compartir resultado",
  dialogTitle: "Compartir resultado",
  dialogSubtitle: "Crea una imagen de este partido para redes sociales. No se sube nada — la imagen se genera en tu dispositivo.",
  showNames: "Mostrar nombres de otros jugadores",
  showLocation: "Mostrar ubicación",
  saveImage: "Guardar imagen",
  shareImage: "Compartir",
  working: "Creando…",
  saved: "Imagen guardada.",
  shared: "Compartido.",
  failed: "No se pudo crear la imagen. Inténtalo de nuevo.",
  shareUnsupported: "Este dispositivo no puede compartir imágenes — usa Guardar imagen.",
  you: "Tú",
  yourTeam: "Tu equipo",
  opponent: "Rival",
  opposingTeam: "Equipo rival",
  victory: "Victoria",
  defeat: "Derrota",
  draw: "Empate",
  retired: "Retirada",
  incomplete: "Incompleto",
  retiredTag: "RET.",
};

export default data;
